import { selectableCountryRegionData } from "@simplyk/common";

// Canvas forms store the country name; the short code only drives search ranking.
export const COUNTRY_NAME_OPTIONS = selectableCountryRegionData.map((country) => ({
  label: country.countryName,
  value: country.countryName,
  shortCode: country.countryShortCode,
}));

export const COUNTRY_NAME_WITH_SHORT_CODE_OPTIONS = selectableCountryRegionData.map((country) => ({
  label: `${country.countryName} (${country.countryShortCode})`,
  value: country.countryName,
  shortCode: country.countryShortCode,
}));
